import {
    AlphaAttribute,
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
} from '../../../attributes';
import { Config } from '../../../../video-data/config';
import type { TextDynamicCircleRendererSettings } from '../renderer/TextDynamicCircleRenderer';
import { TextDynamicCircleRenderer } from '../renderer/TextDynamicCircleRenderer';
import type { Pixels } from '../../../../types';
import { int2rgba } from '../../../../libs/videoData';
import { TextAssetDynamicGraphic } from './TextAssetDynamicGraphic';

export class TextAssetDynamicCircle extends TextAssetDynamicGraphic {
    override _classType = 'CanvasTextDynamicCircle';

    override readonly type = Config.CIRCLE_GRAPHIC;
    @NumberAttribute({ min: 0, max: Infinity })
    accessor radius = 0;
    @ColorAttribute()
    accessor strokeColor = 0xffffff;
    @AlphaAttribute()
    accessor strokeAlpha = 1;
    @NumberAttribute({ min: 0, max: Infinity })
    accessor strokeWidth = 0;
    @ColorAttribute()
    accessor fill = 0xff00ff;
    @AlphaAttribute()
    accessor fillAlpha = 0.5;

    override getCanvasRendererSettings(): TextDynamicCircleRendererSettings {
        const base = super.getCanvasRendererSettings();

        // make the stroke invisible for zero width
        const alpha = this.strokeWidth > 0 ? this.strokeAlpha : 0;
        const style = int2rgba(this.strokeColor, alpha);

        return {
            ...base,
            fill: int2rgba(this.fill, this.fillAlpha),
            type: this.type,
            radius: (this.radius * this.referenceToOutputMultiplier) as Pixels,
            strokeStyle: style,
            lineWidth: (this.strokeWidth * this.referenceToOutputMultiplier) as Pixels,
        };
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(getAttributesToSerialize(this));
    }

    /* The list of properties that can be animated during draw */
    override get animatableProperties() {
        // Since TextDynamicCircle is responsible for rendering our text we need to ask it which properties it
        // supports. See its rendering logic for more details.
        return TextDynamicCircleRenderer.animatableProperties;
    }

    override get animatableGeometricProperties() {
        return TextDynamicCircleRenderer.animatableGeometricProperties;
    }

    override get editableProperties() {
        return super.editableProperties.concat(['fill', 'fillAlpha', 'strokeColor', 'strokeAlpha']);
    }
}
